module.exports = __webpack_public_path__ + "img/Angus.807c8ea1.png";